import { render, staticRenderFns } from "./FoobarSettings.vue?vue&type=template&id=609b753e&scoped=true&"
import script from "./FoobarSettings.vue?vue&type=script&lang=js&"
export * from "./FoobarSettings.vue?vue&type=script&lang=js&"
import style0 from "./FoobarSettings.vue?vue&type=style&index=0&id=609b753e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b753e",
  null
  
)

export default component.exports